import React from "react";

import { BasicLoading } from "ZeroRuby";

import Chrome from "./Chrome";

const LoadingPage = () => (
  <Chrome>
    <BasicLoading />
  </Chrome>
);

export default LoadingPage;
